import { SimplePagination } from "PFComponents/pagination/simple_pagination";

import { useActivityHistoryContext } from "./context";
import { useHistoryTabEvents } from "./hooks/use_history_tab_events";

export const ActivityHistoryFooter = () => {
  const { page, setPage } = useActivityHistoryContext();
  const { data } = useHistoryTabEvents();

  if (data && data?.meta.totalPages > 1) {
    return (
      <SimplePagination
        currentPage={page}
        handleClick={setPage}
        totalPages={data.meta.totalPages}
        scrollOnClick={false}
      />
    );
  }
  return null;
};
